import moment from 'moment';
import { AvailabilitySlot } from 'shared-types/Common';
import type { TimeslotChip } from 'voyager';

export function mapSlotsToTimeslotChips(
  slotsByDate: Record<string, AvailabilitySlot[]>,
  selectedDate: string,
  guestCount?: number
): TimeslotChip[] {
  const daySlots = slotsByDate[selectedDate];
  if (!daySlots || daySlots.length === 0) return [];
  const hasGuestCount = typeof guestCount === 'number' && guestCount > 0;
  return daySlots
    .filter((slot) =>
      hasGuestCount && typeof slot.numberAvailable === 'number'
        ? slot.numberAvailable >= (guestCount as number)
        : true
    )
    .map((slot) => ({
      value: moment(slot.startDateTime).format('HH:mm'),
      label: moment(slot.startDateTime).format('HH:mm'),
      price: slot.price.amount,
      currencyCode: slot.price.currencyCode,
    }));
}
